<!-- @format -->

<template>
	<pcp-selector-dialog
		:value="selectedValue"
		:visible="selectorVisible"
		:label-key="labelKey"
		width="40%"
		title="岗位选择器"
		margin-top="15vh"
		:multiple="multiple"
		@input-main="(value) => (selectedValue = value)"
		@fullscreen="handleFullscreen"
		@remove-select="removeSelect"
		@open="handleOpen"
		@opened="handleOpened"
		@close="handleClose"
		@action-event="handleActionEvent"
	>
		<template #default="scope">
			<pcp-selector-panel
				ref="panel"
				v-bind="scope"
				:height="actualHeight"
				:party-type-id="partyTypeId"
				:current-org-id="currentOrgId"
				:script="script"
				:form-data="formData"
				:is-use-scope="isUseScope"
				:has-subset="hasSubset"
				:pk-key="store === 'bind' ? 'name' : 'id'"
				:party-type="partyType"
				@selected="(value) => (selectedValue = value)"
			/>
		</template>
	</pcp-selector-dialog>
</template>
<script>
	import pcpSelectorPanel from './newPanel';
	import PcpSelectorDialog from '@/p-components/pcp-selector-dialog/dialog';
	import { $utils } from '@/utils/publicUtils';

	// 定义全局变量
	let _that = null;

	export default {
		components: {
			PcpSelectorDialog,
			pcpSelectorPanel,
		},
		props: {
			formData: [Object, Array], // 所有字段数据,(包含主主子表)
			visible: Boolean, // 是否可见
			script: String,
			isUseScope: {
				// 是否启用范围
				type: Boolean,
				default: false,
			},
			partyTypeId: [String, Number],
			currentOrgId: [String, Number],
			title: {
				// 标题
				type: String,
				default() {
					return '岗位选择器';
				},
			},
			marginTop: {
				// Dialog CSS 中的 margin-top 值
				type: String,
				default: '15vh',
			},
			width: {
				// 宽
				type: String,
				default: '40%',
			},
			height: {
				// 高
				type: String,
				default: '345px',
			},
			closeOnClickModal: {
				// 是否可以通过点击 modal 关闭 Dialog
				type: Boolean,
				default: false,
			},
			closeOnPressEscape: {
				// 是否可以通过按下 ESC 关闭 Dialog
				type: Boolean,
				default: false,
			},
			showClose: {
				// 是否显示关闭按钮
				type: Boolean,
				default: true,
			},
			beforeClose: {
				// 关闭前的回调，会暂停 Dialog 的关闭
				type: Function,
			},
			fullscreen: {
				// 是否为全屏 Dialog
				type: Boolean,
				default: false,
			},
			valueKey: {
				// 唯一存储的值
				type: String,
				default: 'id',
			},
			labelKey: {
				// 展示的值
				type: [String, Function],
				default: 'name',
			},
			store: {
				type: String,
				default: 'id',
			},
			value: {
				type: [Object, Array],
				default: () => {
					// 备注：调整外部未传 multiple 时此处报错的问题
					return _that.multiple ? [] : {};
					// return this.multiple ? [] : {};
				},
			},
			cleanClose: {
				// 按钮清空并关闭
				type: Boolean,
				default: false,
			},
			buttons: {
				// 按钮组
				type: Array,
			},
			confirmButtonText: {
				type: String,
				default() {
					return '确认';
				},
			},
			cleanButtonText: String,
			cancelButtonText: String,
			multiple: {
				// 是否多选
				type: Boolean,
				default: false,
			},
			partyType: String,
			hasSubset: {
				// 是否包含子集
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selectorVisible: false,
				selectedValue: this.multiple ? [] : {},
				dialogFullscreen: this.fullscreen,
			};
		},
		computed: {
			actualHeight() {
				return this.dialogFullscreen ? this.getFullscreenDialogHeight() : this.height;
			},
		},
		watch: {
			visible: {
				handler(val) {
					// 设置全局变量值
					_that = this;
					this.selectorVisible = val;
					const valueData = this.multiple ? this.value : $utils.isArray(this.value) ? this.value : [this.value];
					this.selectedValue =
						this.store === 'bind'
							? valueData.map((v) => {
									const name = this.isString(v) ? v : v[this.valueKey];
									const data = {};
									data[this.valueKey] = name;
									return data;
							  })
							: valueData;
				},
				immediate: true,
			},
			fullscreen(val) {
				this.dialogFullscreen = val;
			},
		},
		beforeUnmount() {
			this.selectedValue = null;
		},
		methods: {
			getFullscreenDialogHeight() {
				const h = document.documentElement.clientHeight || document.body.clientHeight;
				return `${h - 60 - 90}px`;
			},
			isString(v) {
				const Booleans = $utils.isString(v);
				return Booleans;
			},
			removeSelect(arr) {
				this.$refs['panel'].setChecked(arr, false);
			},
			handleFullscreen(val) {
				this.dialogFullscreen = val;
			},
			// 打开窗口
			handleOpen() {
				this.$emit('open');
			},
			// 打开窗口后
			handleOpened() {
				this.$emit('opened');
			},
			handleClose(visible) {
				this.$emit('close', visible);
			},
			handleActionEvent(key) {
				// 备注：这里注释掉是因为外部回调事件走了两次
				// this.$emit('action-event', key, data);
				if (key === 'clean') {
					this.$refs['panel'].cleanData(this.multiple);
				}
				if (key === 'cancel') {
					this.selectedValue = [];
				}
			},
		},
	};
</script>
